import(/* webpackMode: "eager" */ "/app/front_end/src/app/global-error.tsx");
